import React, { useContext } from "react";

import AnswersContext from "../contexts/AnswersContext";

import {
  correctQuestionsFromList,
  incorrectQuestionsFromList,
  answeredQuestionsFromList,
  unansweredQuestionsFromList,
} from "../Data";

const ProgressBar = ({ value, total, className, label }) => {
  const progressPercent = value / (total || 1);

  const progressWidth = (() => {
    return Intl.NumberFormat(undefined, {
      style: "percent",
      maximumFractionDigits: 2,
    }).format(progressPercent);
  })();

  const progressString = `${progressWidth} (${value}/${total})`;

  const classNames = `progress-bar ${className}`;

  const styles = {
    width: progressWidth,
  };

  return (
    <div
      className={classNames}
      role="progressbar"
      aria-label={label}
      aria-valuetext={progressString}
      style={styles}
      aria-valuenow={total}
      aira-valuemin="0"
      aira-valuemax="100"
    >
      {progressString}
    </div>
  );
};

const ProgressBars = ({ questions, showAnswers }) => {
  const { answers } = useContext(AnswersContext);
  return (
    <>
      <div className="progress">
        {showAnswers ? (
          <>
            <ProgressBar
              className="bg-success"
              label="correct progress bar"
              value={correctQuestionsFromList(answers, questions).length}
              total={questions.length}
            />
            <ProgressBar
              className="bg-danger"
              label="incorrect progress bar"
              value={incorrectQuestionsFromList(answers, questions).length}
              total={questions.length}
            />
          </>
        ) : (
          <ProgressBar
            className="bg-primary"
            label="answered progress bar"
            value={answeredQuestionsFromList(answers, questions).length}
            total={questions.length}
          />
        )}
        <ProgressBar
          className="bg-white text-dark"
          label="unanswered progress bar"
          value={unansweredQuestionsFromList(answers, questions).length}
          total={questions.length}
        />
      </div>
    </>
  );
};

export default ProgressBars;
